import script from "./ListContract.vue?vue&type=script&lang=ts&setup=true"
export * from "./ListContract.vue?vue&type=script&lang=ts&setup=true"

import "./ListContract.vue?vue&type=style&index=0&id=38de407c&lang=scss"

const __exports__ = script;

export default __exports__